import type { UserRoles } from '../../base';

export class RoleModel {
  name: UserRoles;

  description: string;
}
